import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { ScrollProgress } from './components/ScrollProgress';
import { Home } from './pages/Home';
import { Work } from './pages/Work';
import { CaseStudy } from './pages/CaseStudy';
import { Fleet } from './pages/Fleet';
import { FleetVehicle } from './pages/FleetVehicle';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31cjog1g2xp1w">
      <ScrollToTop data-id="element-1" data-mp="2wka0gqyiyz29" />
      <div className="flex min-h-screen w-full flex-col bg-ink font-sans text-cream" data-id="element-2" data-mp="2wjql9i09eorx">
        <ScrollProgress data-id="element-3" data-mp="28tw44o8wqe1v" />
        <Header data-id="element-4" data-mp="28t4lsf4bmctj" />
        <main className="flex-1" data-id="element-5" data-mp="28sl3uyeo7ofi">
          <Routes data-id="element-6" data-mp="23vcm2yxfpmes">
            <Route path="/" element={<Home data-id="element-8" data-mp="23ujmchww7x65" />} data-id="element-7" data-mp="23vulg4fe8gqx" />
            <Route path="/work" element={<Work data-id="element-10" data-mp="3ijxsgzk2wgo4" />} data-id="element-9" data-mp="23v2u55stx56g" />
            <Route path="/work/:slug" element={<CaseStudy data-id="element-12" data-mp="3ijfthv617oci" />} data-id="element-11" data-mp="3ikr0e3urxc7u" />
            <Route path="/fleet" element={<Fleet data-id="element-14" data-mp="3ml17xky7saot" />} data-id="element-13" data-mp="3ii4q3wgi0ilx" />
            <Route path="/fleet/:slug" element={<FleetVehicle data-id="element-16" data-mp="3mj6ibtbzzuee" />} data-id="element-15" data-mp="3mk852v2dm5by" />
            <Route path="/about" element={<About data-id="element-18" data-mp="3rdkie91luppe" />} data-id="element-17" data-mp="3rbrakqf99zft" />
            <Route path="/contact" element={<Contact data-id="element-20" data-mp="5ot150vj28n" />} data-id="element-19" data-mp="3rd17vdeab3le" />
            <Route path="*" element={<Home data-id="element-22" data-mp="5ggje8nxyxz" />} data-id="element-21" data-mp="682rygdekbl" />
          </Routes>
        </main>
      </div>
    </BrowserRouter>;
}